import React, { useEffect } from 'react';
import Navbar from '../Shared/Navbar/Navbar';
import repairPlus from '../../images/repair-plus.png';
import ponnoBilash from '../../images/ponno-bilash.png';
import doctorsPortal from '../../images/doctors-portal.png'
import crazyRiders from '../../images/crazy-riders.png';
import sport360 from '../../images/sport360.png';
import barcelonaClub from '../../images/barcelona-club.png';
import './Projects.css';
import Footer from '../Shared/Footer/Footer';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGithub } from '@fortawesome/free-brands-svg-icons';
import { faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons';
import Aos from 'aos';

const Projects = () => {
    useEffect(() => {
        Aos.init({ duration: 1500 });
    }, [])
    return (
        <section className="container">
            <div>
                <Navbar></Navbar>
            </div>
            <div data-aos="zoom-out-down" className="pt-4 pb-4 text-center text-white lh-base">
                <h3>Portfolio</h3>
                <h5 className="fst-italic">Some of the projects I worked on</h5>
            </div>
            <div data-aos="zoom-out-up" className="row row-cols-1 row-cols-md-3 g-4 pt-5 pb-5">
                <div className="col">
                    <div className="card">
                        <img src={repairPlus} className="card-img-top" alt="..." />
                        <div className="card-body">
                            <h5 className="card-title">Repair Plus</h5>
                            <p className="card-text text">This is an electronic devices repair service based website. Users can review and show order lists and Admin can add, delete and also update any service.</p>
                            <p><strong>Technology:</strong> React.js, Node.js, Bootstrap, MongoDB, Firebase</p>
                            <div className="card-footer d-flex justify-content-between">
                                <a className="link" href="https://github.com/nibirbu24/repair-plus-client" target="_blank"><FontAwesomeIcon icon={faGithub} /> Github</a>
                                <a className="link" href="https://repair-plus-32417.web.app/" target="_blank"><FontAwesomeIcon icon={faExternalLinkAlt} /> Live</a>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col">
                    <div className="card">
                        <img src={ponnoBilash} className="card-img-top" alt="..." />
                        <div className="card-body">
                            <h5 className="card-title">Ponno Bilash</h5>
                            <p className="card-text text">This is an ecommerce site. Customers can login using email and password or google and order products online. Admin can add new products and delete any products.</p>
                            <p><strong>Technology:</strong> React.js, Node.js, Bootstrap, MongoDB, Firebase</p>
                            <div className="card-footer d-flex justify-content-between">
                                <a className="link" href="https://github.com/nibirbu24/ponno-bilash-client" target="_blank"><FontAwesomeIcon icon={faGithub} /> Github</a>
                                <a className="link" href="https://ponno-bilash.web.app/" target="_blank"><FontAwesomeIcon icon={faExternalLinkAlt} /> Live</a>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col">
                    <div className="card">
                        <img src={doctorsPortal} className="card-img-top" alt="..." />
                        <div className="card-body">
                            <h5 className="card-title">Doctors Portal</h5>
                            <p className="card-text text">In this project, users can get appointments from doctor. Users must have to login or signup to get appointment. Admin can add any doctor and Users can add reviews.</p>
                            <p><strong>Technology:</strong> React.js, Node.js, Bootstrap, MongoDB, Firebase</p>
                            <div className="card-footer d-flex justify-content-between">
                                <a className="link" href="https://github.com/nibirbu24/doctors-portal-client" target="_blank"><FontAwesomeIcon icon={faGithub} /> Github</a>
                                <a className="link" href="https://doctors-portal-c77ee.web.app/" target="_blank"><FontAwesomeIcon icon={faExternalLinkAlt} /> Live</a>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col">
                    <div className="card">
                        <img src={crazyRiders} className="card-img-top" alt="..." />
                        <div className="card-body">
                            <h5 className="card-title">Crazy Riders</h5>
                            <p className="card-text text">A single page application. Authentication system included. Users can log in and sign up using email and password or google. Available rides are shown.</p>
                            <p><strong>Technology:</strong> React.js, Bootstrap, Firebase, Javascript</p>
                            <div className="card-footer d-flex justify-content-between">
                                <a className="link" href="https://github.com/nibirbu24/crazy-riders" target="_blank"><FontAwesomeIcon icon={faGithub} /> Github</a>
                                <a className="link" href="https://react-auth-43982.web.app/" target="_blank"><FontAwesomeIcon icon={faExternalLinkAlt} /> Live</a>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col">
                    <div className="card">
                        <img src={sport360} className="card-img-top" alt="..." />
                        <div className="card-body">
                            <h5 className="card-title">Sport360</h5>
                            <p className="card-text text">In this site, different types of leagues are shown using API. Users can show league details by clicking the explore button. Dynamic routing is used in this site.</p>
                            <p><strong>Technology:</strong> React.js, Bootstrap, HTML, CSS, API, Javascript</p>
                            <div className="card-footer d-flex justify-content-between">
                                <a className="link" href="https://github.com/nibirbu24/sport-360" target="_blank"><FontAwesomeIcon icon={faGithub} /> Github</a>
                                <a className="link" href="https://nostalgic-liskov-6bea80.netlify.app/" target="_blank"><FontAwesomeIcon icon={faExternalLinkAlt} /> Live</a>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col">
                    <div className="card">
                        <img src={barcelonaClub} className="card-img-top" alt="..." />
                        <div className="card-body">
                            <h5 className="card-title">Barcelona Club</h5>
                            <p className="card-text text">Club players with details are shown using data. Players will be added by clicking Add Player button. Added players total salary can be calculated.</p>
                            <p><strong>Technology:</strong> React.js, HTML, CSS, Bootstrap, Javascript</p>
                            <div className="card-footer d-flex justify-content-between">
                                <a className="link" href="https://github.com/nibirbu24/barcelona-club" target="_blank"><FontAwesomeIcon icon={faGithub} /> Github</a>
                                <a className="link" href="https://vigilant-noyce-e3aa29.netlify.app/" target="_blank"><FontAwesomeIcon icon={faExternalLinkAlt} /> Live</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div>
                <Footer></Footer>
            </div>
        </section>
    );
};

export default Projects;